module.exports = __webpack_public_path__ + "img/background.97748824.png";